export const isAuthed = ({
  positions,
  timeout=3600000,
  login,
  login_email,
  login_positions,
  login_time,
}) => {
  if (!login) {
    return false;
  }
  if (login_time + timeout < Date.now()) {
    return false;
  }
  if (positions === undefined || positions === null || positions.length === 0) {
    return true;
  }
  if (login_positions === undefined || login_positions === null || login_positions.size === 0) {
    return false;
  }
  for (const pos of positions) {
    if (pos === 'board') {
      return true;
    } else if (login_positions.has(pos)) {
      return true;
    }
  }
  return false;
};

export const AuthRequired = ({ noauth, children, ...info }) => {
  if (noauth) {
    return isAuthed(info) ? null : children;
  }
  return isAuthed(info) ? children : null;
};
